import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { captureRef } from './api/client'
import './index.css'

// Persist a referral tag (?ref=mike) at boot so it survives the whole funnel.
captureRef()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
